// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__DVKY5","line":"section_line__3ze_D","paragraph":"section_paragraph__3MJf2"};